/**
 * Footer Klaviyo sign-up submit
 */

window.addEventListener("DOMContentLoaded", () => {
  const error = document.querySelector('#ContactFooter-error');
  const form = document.querySelector('#ContactFooter');
  const success = document.querySelector('#ContactFooter-success');
  const input = document.querySelector('#k_id_email');
  const url = "https://a.klaviyo.com/client/subscriptions/?company_id=Um89mB";

  form.addEventListener('submit', (event) => {
    event.preventDefault();

    const options = {
      method: "POST",
      headers: { revision: "2024-02-15", "content-type": "application/json" },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            custom_source: "CH footer signup form",
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: input.value,
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: "QRdGby",
              },
            },
          },
        },
      }),
    };

    fetch(url, options)
      .then((response) => {
        if (!response.ok) {
          error.classList.add('active');
          success.classList.remove('active');
          return;
        }

        error.classList.remove('active');
        success.classList.add('active');
      })
      .catch((error) => {
        console.error(error);
      })
  });
});
  